import * as React from 'react';
import * as cn from 'classnames';
import { Button } from '@mq/aurora-components/dist/button';

import { Footer } from '../footer/footer';
import { Disclaimer } from '../disclaimer/disclaimer';
import { Header } from '../header/header';
import { HeaderMobile } from '../header-mobile/header-mobile';
import { IBaseProps } from '../../types/props';
import { Diversity, Map } from './sections';
import { logGAPageView } from '../../utils/google-analytics';

const hero = require('../../assets/images/hero-careers.png') as string;
const mqLogo = require('../../assets/images/mq-logo-tm.png') as string;
import { isWebPSupported } from '../../utils/webp-supported';
import * as grid from '../../styles/grid.css';
import * as heroStyle from '../../styles/hero.css';
import * as styles from './careers.css';

const CAREERS_URL: string =
  'https://globalcareers-goldmansachs.icims.com/jobs/search?ss=1&searchKeyword=marquee&searchRelation=keyword_all';

interface ICareersProps extends IBaseProps {
  history: {
    push: (url: string) => void;
  };
}

export class Careers extends React.PureComponent<ICareersProps, {}> {
  componentDidMount() {
    // Scroll to top when component is loaded
    window.scrollTo(0, 0);
    logGAPageView();
  }

  render() {
    const {
      history: { push },
      match
    } = this.props;

    const style: React.CSSProperties = {
      backgroundImage: `url(${isWebPSupported() ? hero : hero})`
    };

    return (
      <div>
        <Header match={match} push={push} />
        <HeaderMobile match={match} />

        <div className={cn(heroStyle.hero, heroStyle.heroCareers, heroStyle.cover)} style={style}>
          <div className={grid.container}>
            <div className={heroStyle.content} style={{ maxWidth: '600px' }}>
              <h1>Build the Future of Finance</h1>
              <p>
                Get ready to make things possible. We are a team of engineers, designers, and
                product managers collaborating to drive innovation and elevate digital finance.
              </p>
              <a href={CAREERS_URL}>
                <Button
                  className={heroStyle.btn}
                  ghost
                  size="large"
                  // Override the color
                  style={{ color: '#00B368' }}
                  type="primary"
                >
                  VIEW OPEN ROLES
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className={cn(grid.section, styles.banner)}>
          <div className={cn(grid.container, styles.container)}>
            <div className={styles.left}>
              <img src={mqLogo} />
            </div>
            <div className={styles.right}>
              We believe that by surrounding ourselves with big thinkers who thrive on tackling
              fresh challenges and uniting around a common vision we become an unstoppable team. We
              believe in moving fast, changing constantly, and welcoming fresh perspectives. We
              believe few things are as engaging as sitting at the center of global financial
              markets for one of the biggest financial firms in the world. We believe in building
              the future of finance.
              <br />
              <br />
              <span>Finance background not required. And you can wear jeans.</span>
            </div>
          </div>
        </div>

        <div className="map">
          <Map />
        </div>

        <div className="diversity">
          <Diversity />
        </div>

        {/*<div className="quote">*/}
        {/*<Quote />*/}
        {/*</div>*/}

        <div className={cn(grid.section, styles.action)}>
          <div className={grid.container}>
            <h3>Ready to build the future of finance?</h3>
            <a href={CAREERS_URL} target="_blank">
              <Button className={styles.btn} ghost size="large" type="default">
                APPLY NOW
              </Button>
            </a>
          </div>
        </div>

        <Footer />
        <Disclaimer match={match} />
      </div>
    );
  }
}
